// lib/events/modal

/**
 * Запускает по событию name модальное окно с e
 */

var name = 'number'
const debug = window.debug

var components = {
  'bill-list': ['bill-info', 'cnt-info', 'bill-list'],
  'bill-info': ['bill-info'],
  'cnt-list':  ['bill-info', 'cnt-info', 'bill-list'],
  'auto-import-list':  ['auto-import'],
  'auto-import':  ['auto-import'],
  'cnt-info':  ['cnt-info', 'bill-list'],
  'cnt-poezd':  ['cnt-info', 'auto-export-poezd'],
  'auto-export-poezd':  ['auto-export-poezd'],
  'auto-export-cnt':  ['auto-export-cnt'],
  'train-in-way-info':  ['train-in-way-info'],
  'close-store':  ['close-store'],
}

function Modal (e) {
  var eventName = 'number:' + e.name
  // сначало очистим модальное окно
  this.$set('modal.show', false)
  this.$set('modal.components', [])
  // затем создадим новое модальное окно
  this.$nextTick( () => {
    this.$set('modal.components', components[e.name])
    this.$set('modal.show', true)
    this.$nextTick( () => this.$broadcast(eventName, e) )
  })
}

export default {events: {number: Modal}}



/** WEBPACK FOOTER **
 ** ./src/js/lib/events/modal.js
 **/